// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-verification {
  --input-height: 60px;
}

.page-verification .button-container {
  margin-top: 50px;
  padding: 0 30px;
}

.page-verification .resend-container {
  margin-top: 30px;
  text-align: center;
}

.page-verification .contacts-container {
  margin-top: 30px;
  text-align: center;
}

.page-verification .back-button-container {
  margin-top: 30px;
  text-align: center;
}

.page-verification .back-button-container a{
  text-decoration: underline;
  text-underline-position: under;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/verification.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC","sourcesContent":[".page-verification {\n  --input-height: 60px;\n}\n\n.page-verification .button-container {\n  margin-top: 50px;\n  padding: 0 30px;\n}\n\n.page-verification .resend-container {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.page-verification .contacts-container {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.page-verification .back-button-container {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.page-verification .back-button-container a{\n  text-decoration: underline;\n  text-underline-position: under;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
